import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
/**
 * @type {React.FunctionComponent<{as: React.ComponentType}>}
 */
const Base = /*#__PURE__*/function () {
  const Base = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      as: Component,
      ...rest
    } = props;
    return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
      ref: ref
    }));
  });
  Base.displayName = 'Base';
  Base.identifier = Base.displayName;
  Base.defaultProps = {
    as: 'div'
  };
  return Base;
}();
export default Base;